import {useContext} from 'react';

import UserSecretsContext from '../../contexts/UserSecretsContext';

const useUserSecrets = () => {
  return useContext(UserSecretsContext);
};

export default useUserSecrets;
